import {
  iStore,
  NOTIFICATION_TYPE,
} from 'react-notifications-component/dist/src/typings';

import { NotificationLevel } from '../store/reducers/notifications.type';

export const addNotification = (
  store: iStore,
  title: string,
  message: string,
  type: NOTIFICATION_TYPE,
) => {
  store.addNotification({
    title: `${title}`,
    message: `${message}`,
    type: `${type}`,
    container: 'bottom-right',
    animationIn: ['animate__animated animate__fadeIn'],
    animationOut: ['animate__animated animate__fadeOut'],
    dismiss: {
      duration: 10000,
      onScreen: true,
      pauseOnHover: true,
      showIcon: true,
    },
  });
};

// eslint-disable-next-line
export const throwError = (error: any) => {
  // eslint-disable-next-line
  if (error.response) {
    // eslint-disable-next-line
    if (error.response.data) {
      throw new Error(error.response.data); // eslint-disable-line
    } else {
      throw new Error(error.response.statusText); // eslint-disable-line
    }
  } else {
    throw new Error('Unknown Error');
  }
};

export const getNotificationColor = (level: NotificationLevel) => {
  switch (level) {
    case NotificationLevel.INFO: {
      return '#cbdef9';
    }

    case NotificationLevel.WARNING: {
      return '#fbdfac';
    }

    case NotificationLevel.CRITICAL: {
      return '#ff6363';
    }

    default:
      return '#cbdef9';
  }
};
